// extracted by mini-css-extract-plugin
module.exports = {"formOpinion":"FormOpinion_formOpinion__1YTkV","score":"FormOpinion_score__yRcnq","title":"FormOpinion_title__2-RAp","text-area":"FormOpinion_text-area__3v2yj"};